import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Header.module.scss";
import { Dropdown, HStack, Input, IconButton, Text, Avatar } from "rsuite";
import { RiSearchLine } from "react-icons/ri";
import { IoNotificationsOutline } from "react-icons/io5";
import { IoMdLogOut } from "react-icons/io";
import { LeadSearchDropdown } from "constants/master";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import AdminAPI from "services/AdminAPI";
import Helper from "lib/helper";
import { useNavigate } from "react-router-dom";
import { fetchLoggedInUser } from "../../redux/slices/apiSlices";

export default function Header() {
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    name: "Mobile",
    value: "mobile",
  });
  const searchRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminInfoData = useSelector((state) => state.loggedInUser);
  const adminInfo = adminInfoData.data.data;

  const apiInstance = useMemo(() => new AdminAPI(), []);

  useEffect(() => {
    const fetchUser = async () => {
      await dispatch(fetchLoggedInUser());
    };
    fetchUser();
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("userId", adminInfo?.userID);
  }, [adminInfo]);

  useEffect(() => {
    const getData = setTimeout(() => {
      const fetchData = async () => {
        if (searchValue.length > 2) {
          const params = selectedValue.value + "=" + searchValue;
          const res = await apiInstance.customerSearchAPI(params);
          if (res && res.statusCode === 200) {
            setData(res.data);
            setShowAutoComplete(true);
          } else {
            setData(null);
          }
        }
      };

      fetchData();
    }, 1000);

    return () => clearTimeout(getData);
  }, [searchValue]);

  // Handle click outside to close autoComplete
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowAutoComplete(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const clearSearchInputValue = (value) => {
    setData(null);
    setSearchValue("");
  };

  const onSearchInputChange = (value) => {
    if (!value.length) {
      clearSearchInputValue();
    } else {
      setSearchValue(value);
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.search}>
        <form>
          <HStack>
            <div className={styles.searchInner} ref={searchRef}>
              <Input
                value={searchValue}
                placeholder="Search"
                icon={<RiSearchLine />}
                onChange={onSearchInputChange}
                onFocus={() => {
                  if (searchValue.length > 2) {
                    data && data.length && setShowAutoComplete(true);
                  } else {
                    setShowAutoComplete(false);
                  }
                }}
              />
              <div className={styles.icon}>
                <RiSearchLine size={17} color="#a1a1a1" />
              </div>
              <div className={styles.dropdownMenu}>
                <Dropdown
                  title={selectedValue.name}
                  onSelect={(eventKey) => {
                    if (eventKey.value !== selectedValue.value) {
                      clearSearchInputValue();
                    }
                    setSelectedValue({ ...eventKey });
                    setShowAutoComplete(false);
                  }}
                  onOpen={() => setShowAutoComplete(false)}
                >
                  {LeadSearchDropdown.map((item) => (
                    <Dropdown.Item eventKey={item} key={item.value}>
                      {item.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown>
              </div>

              {showAutoComplete && data !== null && searchValue.length > 2 && !data?.length ? (
                <div className={styles.autoComplete}>
                  <HStack className={styles.list}>Lead not found</HStack>
                </div>
              ) : null}

              {showAutoComplete && data && data.length > 0 && (
                <div className={styles.autoComplete}>
                  {data.map((item, index) => (
                    <HStack
                      className={styles.list}
                      key={index}
                      onClick={() => {
                        setData(null);
                        setShowAutoComplete(false);
                        window.location.href = `/customer-lead-profile/${item.leadID}`;
                      }}
                    >
                      <MdKeyboardDoubleArrowRight />
                      <span>
                        {item.name} ({item.mobile})
                      </span>
                    </HStack>
                  ))}
                </div>
              )}
            </div>
          </HStack>
        </form>
      </div>

      <div className={styles.user}>
        <div className={styles.notification}>
          <IoNotificationsOutline color="#4e4e4e" size={18} />
        </div>
        <div className={styles.userInfo}>
          <Avatar src="https://i.pravatar.cc/150?u=2" circle />
          <div className={styles.userName}>
            <Text>
              {Helper.capitalizeFirstLetter(adminInfo?.name)} <span className={styles.departmentName}>({adminInfo?.department_name})</span>
            </Text>
            <div>
              {adminInfo?.role} ({adminInfo?.userID})
            </div>
          </div>
          <div>
            <IconButton circle size="lg" onClick={() => navigate("/logout")} icon={<IoMdLogOut size={22} color="#111111" />} appearance="link" />
          </div>
        </div>
      </div>
    </header>
  );
}
